import styled from 'styled-components';

import colors from 'themes/Main';

const { darkBlue, gray01 } = colors;

export const Infos = styled.div`
  margin: -16px 0 16px;
`;

export const Label = styled.span`
  font-size: 14px;
  color: ${darkBlue};
  font-weight: 700;
  margin-bottom: 4px;
`;

export const EmployeeName = styled.p`
  margin-bottom: 0;
  color: ${gray01};
`;

export const Options = styled.div``;

export const FormGroup = styled.div`
  margin: 20px 0;
`;

export const ActionButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 40px;

  button + button {
    margin-left: 16px;
  }
`;
